<template>
  <div class="dialog" v-if="dialogDisplay">
    <div class="layer in">
      <div class="content">{{param.message}}</div>
      <div class="btn-confirm" @click="btnConfirm(param.url)">确 定</div>
      <div class="btn-close" @click="btnClose">
        <i class="iconfont icon-guanbi"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    param: Object
  },
  data() {
    return {
      dialogDisplay: false,
    }
  },
  methods: {
    btnClose() {
      this.dialogDisplay = false
    },
    btnConfirm(url) {
      this.btnClose()
      // 跳转动作
      url && (window.location.href = url)
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0, 0, 0, 0.5)
  z-index: 9
  font-size: 0.14rem
  .layer
    margin: 1.26rem auto 0
    box-sizing: border-box
    padding: 0.4rem 0.24rem 0.35rem
    width: 3rem
    min-height: 1.8rem
    border-radius: 0.1rem
    background: #fff
    text-align: center
    // overflow: hidden
    position: relative
    &.in
      animation: btnin 0.2s
      @keyframes btnin {
        0% {opacity: 0}
        100% {opacity: 1}
      }
    .content
      margin-bottom: 0.3rem
      min-height: 0.5rem
      // width: 80%
      text-align: left
      line-height .2rem
    .btn-confirm
      margin: auto
      width: 0.96rem
      height: 0.3rem
      line-height: 0.3rem
      border-radius: 0.06rem
      background-color: #ec4d5e
      background-color: var(--color)
      color: #fff
    .btn-close
      position: absolute
      top: -0.1rem
      right: -0.1rem
      width: 0.24rem
      height: 0.24rem
      border-radius: 0.12rem
      background-color: #ec4d5e
      background-color: var(--color)
      display: flex
      justify-content: center
      align-items: center
      .iconfont
        color: #fff
</style>
